<template>
  <div class="pa-10">
    <div class="back">
      <v-row no-gutters class="ml-4">
        <v-col cols="12" md="2" sm="2">
          <router-link
            class="mr-2"
            :to="{ name: 'reports' }"
            :style="{ color: link }"
            >/Reportes de usuarios</router-link
          >
        </v-col>
      </v-row>
    </div>
    <br />
    <v-card :color="color" dark elevation="24">
      <v-card-title class="justify-center">
        <caption
          class="font-weight-regular pt-1 headline"
          aria-label="Reporte de Habilidades"
        >
          <p>Reporte de habilidades</p>
        </caption>
      </v-card-title>
      <v-card-text class="white--text">
        <v-row>
          <v-col cols="0" sm="0" md="0">
            <div
              v-for="(organization, index) in organizations"
              :key="`organization-${index}`"
            >
              <p
                class="text-padding"
                v-if="organization.id == $route.params.id"
              >
                <template v-if="organization.logo_url != ''">
                  <v-img
                    height="200"
                    width="200"
                    :src="organization.logo_url"
                  ></v-img>
                </template>
                <template v-else>
                  <v-img
                    height="150"
                    width="150"
                    :src="'/img/camera-off.png'"
                  ></v-img>
                </template>
              </p>
            </div>
          </v-col>
          <v-col cols="15" sm="8" md="8" class="ml-4">
            <v-row>
              <p class="font-weight-regular title">Nombre:</p>
              <p class="font-weight-light ml-2 title">
                {{ report.name }} {{ report.last_name }}
              </p>
            </v-row>
            <v-row>
              <p class="font-weight-regular title">Edad:</p>
              <p class="font-weight-light ml-2 title">{{ report.age }}</p>
            </v-row>
            <v-row>
              <p class="font-weight-regular title">
                Necesidades específicas de apoyo:
              </p>
              <p class="font-weight-light ml-2 title">
                {{ report.diagnostic }}
              </p>
            </v-row>
            <v-row>
              <p class="font-weight-regular title">Características:</p>
              <p class="font-weight-light ml-2 title">
                {{ report.characteristic }}
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-row style="padding-left: 216px">
        <v-col cols="5">
          <v-select
            class="mr-3"
            v-model="item"
            :items="selectAbilities"
            label="Habilidades"
            item-text="label"
            item-value="value"
            @input="filterquery"
          ></v-select>
        </v-col>
        <v-col cols="5">
          <v-select
            class="mr-3"
            v-model="period"
            :items="selectPeriods"
            @input="filterquery"
            label="Periodo"
            item-text="label"
            item-value="value"
          ></v-select>
        </v-col>
        <v-col cols="1" class="mt-3 text-center">
          <v-tooltip bottom :color="tooltip_color">
            <template v-slot:activator="{ on }">
              <v-btn
                @click="download"
                :color="icon_color"
                dark
                depressed
                class="mr-2 ml-2"
                v-on="on"
              >
                <v-icon center>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>Imprimir</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <div v-for="(row, index) in report.abilities" :key="index">
        <div class="title ml-2" v-if="item == 0 || item == row.ability_id">
          Habilidad: {{ row.ability_name }}
          <span class="caption" :style="{ color: '#FBC02D' }"
            >({{ row.session.length }} registros)</span
          >
          <v-data-table
            :style="{ 'background-color': color, color: '#FBC02D' }"
            :search="period.searchValue"
            dark
            :headers="headers"
            :items="row.session"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-all-text': 'Todos',
              'items-per-page-text': 'Registros por página',
              'items-per-page-options': [10, 20, -1],
              'show-current-page': true,
              pagination: {},
            }"
            no-results-text="No se encuentran resultados"
            no-data-text="No hay datos ingresados"
          >
            <template v-slot:item.code="{ item }">
              <div class="white--text">{{ item.code }}</div>
            </template>
            <template v-slot:item.period="{ item }">
              <div class="white--text">{{ item.period }}</div>
            </template>
            <template v-slot:item.videogame_name="{ item }">
              <div class="white--text">{{ item.videogame_name }}</div>
            </template>
            <template v-slot:item.progress="{ item }">
              <div class="white--text">{{ item.progress }}</div>
            </template>
            <template v-slot:item.date="{ item }">
              <div class="white--text">{{ dateFormat(item.date) }}</div>
            </template>
            <template v-slot:item.state="{ item }">
              <div v-for="(stat, index) in status" :key="index">
                <p v-if="item.state == stat.id" class="white--text">
                  {{ stat.text }}
                </p>
              </div>
            </template>
            <template v-slot:item.time_played="{ item }">
              <p class="white--text">{{ timeFormater(item.time_played) }}</p>
            </template>
          </v-data-table>
        </div>
      </div>
      <div v-if="report.abilities" class="subtitle-2 text-center my-5">
        <div
          v-if="report.abilities.length == 0"
          class="subtitle-1 text-center my-5"
        >
          No existen registros para los criterios de busqueda selecionados
        </div>
        <br />
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import deleteMixin from '../../mixins/deletemixin'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  mixins: [deleteMixin],

  created() {
    this.$store.commit('layout/SET_LAYOUT', 'tutor-layout')
    this.$store.dispatch('videogame/fetchVideogames')
    this.$store.dispatch('ability/fetchAbilities', this.$route.params.id)
    this.$store.dispatch('abilityReport/fetchAbilityFilteredReport', {
      player_id: this.$route.params.player_id,
      ability_id: 0,
      period_id: this.$route.params.period_id,
    })
    this.$store.dispatch('organization/fetchOrganizations')
    this.$store.dispatch('period/fetchPeriods', this.$route.params.id)
  },
  computed: {
    ...mapState({
      color: (state) => state.layout.color,
      link: (state) => state.layout.primary,
      icon_color: (state) => state.layout.icon_color,
      tooltip_color: (state) => state.layout.tooltip_color,
      abilities: (state) => state.ability.abilities,
      organizations: (state) => state.organization.organizations,
      report: (state) => state.abilityReport.filterdReport,
      filterdReport: (state) => state.abilityReport.filterdReport,
      periods: (state) => state.period.periods,
    }),
    selectAbilities() {
      var initialValue = { value: 0, label: 'Todos' }
      var mappedArray = this.abilities.map((element) => ({
        value: element.id,
        label: element.name,
      }))
      mappedArray.push(initialValue)

      return mappedArray.reverse()
    },
    selectPeriods() {
      if (this.periods) {
        this.checkDefault(this.periods)
      }
      var initialValue = {
        value: { id: 0, searchValue: '' },
        label: 'Todos',
      }
      var array = this.periods.map((element) => ({
        value: { id: element.id, searchValue: element.name },
        label: element.name,
      }))
      array.unshift(initialValue)

      return array
    },
  },
  data() {
    return {
      period: '',
      item: 0,
      base64: 'sss',
      gameid: this.$route.params.game_name,
      dialog: false,
      disabled: false,
      status: [
        { id: 0, text: 'En progreso' },
        { id: 1, text: 'Terminado' },
        { id: 2, text: 'Cancelado' },
      ],
      headers: [
        { text: 'FECHA (dd/mm/aa)', value: 'date', sortable: true },
        {
          text: 'PLAN DE INTERVENCIÓN',
          align: 'left',
          value: 'code',
        },
        {
          text: 'ESTADO',
          align: 'left',
          value: 'state',
        },
        {
          text: 'PERIODO',
          value: 'period',
        },

        {
          text: 'JUEGO',
          value: 'videogame_name',
        },
        {
          text: 'TIEMPO DE JUEGO',
          value: 'time_played',
        },
        {
          text: 'PROGRESO',
          value: 'progress',
        },
      ],
      errorIMG:
        'data:image/jpeg;base64,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',
    }
  },
  methods: {
    filterquery() {
      this.$store.dispatch('abilityReport/fetchAbilityFilteredReport', {
        player_id: this.$route.params.player_id,
        ability_id: this.item,
        period_id: this.period.id,
      })
    },
    checkDefault(periods) {
      if (periods) {
        var lastPeriod = periods[periods.length - 1]
        if (lastPeriod) {
          this.period = { id: lastPeriod.id, searchValue: lastPeriod.name }
        }
      }
    },
    timeFormater(time) {
      var minutes = time / 60
      var seconds = time % 60
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return minutes.toFixed(0) + ':' + seconds
    },
    async download() {
      var doc = new jsPDF('p', 'mm', 'a4')
      //HEAD
      doc.setDrawColor(0)
      doc.setFillColor(90, 135, 172)
      doc.rect(0, 0, 600, 52, 'F')
      doc.setFillColor(189)
      doc.rect(48, 20, 600, 32, 'F')
      doc.setFontSize(24)
      doc.setFont('Helvetica', 'bold')
      doc.setTextColor(255)

      //Texto centrado
      var title = ' Reporte de habilidades'
      var xOffset =
        doc.internal.pageSize.width / 2 - doc.getStringUnitWidth(title) * 4
      doc.text(' Reporte de habilidades', xOffset, 15)

      //Leyendas de la cabecera
      doc.setFontSize(12)
      doc.setTextColor(255)
      doc.setFont('Helvetica', 'bold')
      doc.text('Nombre: ', 52, 27)
      doc.text('Edad: ', 169, 27)
      doc.text('Características: ', 52, 34)
      doc.text('Necesidades específicas de apoyo: ', 52, 41)

      //Contenido de las leyendas de la cabecera
      doc.setFont('Helvetica', 'normal')
      doc.setTextColor(242, 242, 242)
      doc.setTextColor(255)
      doc.setFontSize(10)
      doc.text(this.report.name + ' ' + this.report.last_name, 72, 27)
      doc.text(this.report.age + ' años', 182, 27)
      doc.text(this.report.characteristic, 85, 34)
      doc.text(this.report.diagnostic, 52, 47)

      var logo
      for (var i = 0; i < this.organizations.length; i++) {
        if (this.organizations[i].id == this.$route.params.id) {
          logo = this.organizations[i].logo_url
        }
      }
      var logoURI
      if (logo != '') {
        logoURI = await this.getDataUri(logo)
      } else {
        logoURI = this.errorIMG
      }
      doc.addImage(logoURI, 'JPEG', 15, 31, 33, 33)
      doc.setTextColor(0)
      doc.setFontSize(12)
      doc.setFont('Helvetica', 'normal')
      //eslint-disable-next-line

      var startYTable
      var columns = [
        { title: 'Fecha\n(dd/mm/aa)', dataKey: 'date' },
        { title: 'Plan\nIntervención', dataKey: 'code' },
        { title: 'Estado', dataKey: 'state' },
        { title: 'Periodo', dataKey: 'period' },
        { title: 'Juego', dataKey: 'videogame_name' },
        { title: 'Tiempo\njugado', dataKey: 'time_played' },
        { title: 'Progreso', dataKey: 'progress' },
      ]
      var abilities = JSON.parse(JSON.stringify(this.filterdReport.abilities))

      abilities.map(function (abilities) {
        abilities.session.map(function (session) {
          if (session.state == 0) {
            session.state = 'En progreso'
          }
          if (session.state == 1) {
            session.state = 'Terminado'
          }
          if (session.state == 2) {
            session.state = 'Cancelado'
          }
          session.date = dateFormat(session.date)
          session.time_played = timeFormater(session.time_played)
        })
        function dateFormat(date) {
          var year = date.slice(0, 4)
          var day = date.slice(8, 10)
          var month = date.slice(5, 7)

          return day + '/' + month + '/' + year
        }
        function timeFormater(time) {
          var minutes = time / 60
          var seconds = time % 60
          if (seconds < 10) {
            seconds = '0' + seconds
          }
          return minutes.toFixed(0) + ':' + seconds
        }
      })
      for (i = 0; i < abilities.length; i++) {
        if (doc.previousAutoTable.finalY == undefined) {
          startYTable = 67
        } else {
          startYTable = doc.previousAutoTable.finalY + 15
        }
        doc.autoTable({
          theme: 'grid',
          pageBreak: 'auto',
          startY: startYTable,
          body: abilities[i].session,
          columns: columns,
          head: [
            [
              {
                content: 'Habilidad ' + abilities[i].ability_name.toLowerCase(),
                colSpan: 7,
                styles: {
                  halign: 'center',
                  fontSize: 13,
                  fillColor: [189, 189, 189],
                  lineWidth: 0.1,
                },
              },
            ],
            columns,
          ],
          headStyles: {
            fillColor: [107, 174, 246],
            lineWidth: 0.1,
            halign: 'center',
            valign: 'middle',
            font: 'helvetica',
            fontSize: 11,
          },
          bodyStyles: {
            halign: 'center',
            valign: 'middle',
            font: 'helvetica',
            fontSize: 10,
            textColor: 20,
          },
        })
      }
      var pageCount = doc.internal.getNumberOfPages()
      for (i = 0; i < pageCount; i++) {
        doc.setPage(i)
        doc.text(190, 290, doc.internal.getCurrentPageInfo().pageNumber + '')
      }
      doc.save('reporte_habilidades.pdf')
    },
    async getDataUri(url) {
      return new Promise((resolve) => {
        var image = new Image()
        image.setAttribute('crossOrigin', 'anonymous') //getting images from external domain

        image.onload = function () {
          var canvas = document.createElement('canvas')
          canvas.width = this.naturalWidth
          canvas.height = this.naturalHeight

          //next three lines for white background in case png has a transparent background
          var ctx = canvas.getContext('2d')
          ctx.fillStyle = '#fff' /// set white fill style
          ctx.fillRect(0, 0, canvas.width, canvas.height)

          canvas.getContext('2d').drawImage(this, 0, 0)

          resolve(canvas.toDataURL('image/jpeg'))
        }

        image.src = url
      })
    },
    dateFormat(date) {
      var year = date.slice(0, 4)
      var day = date.slice(8, 10)
      var month = date.slice(5, 7)

      return day + '/' + month + '/' + year
    },
  },
}
</script>

<style scoped>
.text-padding {
  padding-left: 10px;
  padding-bottom: 0px;
  font-size: medium;
  color: whitesmoke;
}
</style>